import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { ConsentTemplateDto } from '@/features/dashboard/consentTemplates/types/ConsentTemplateDto.ts';
import { ConsentTemplateListDto } from '@/features/dashboard/consentTemplates/types/ConsentTemplateListDto.ts';
import { InitUploadRequest, InitUploadResponse } from '@/lib/upload/types.ts';
import { TemplateVariableDefinitionDto } from '@/features/dashboard/messageTemplates/types/TemplateVariableDefinitionDto.ts';

const consentTemplatesApi = {
  create: async (dto: ConsentTemplateDto): Promise<ConsentTemplateDto> => {
    return await fetchPrivateApi<ConsentTemplateDto>(
      'POST',
      `consent-templates`,
      dto,
    );
  },
  update: async (
    id: string,
    dto: ConsentTemplateDto,
  ): Promise<ConsentTemplateDto> => {
    return await fetchPrivateApi<ConsentTemplateDto>(
      'PUT',
      `consent-templates/${id}`,
      dto,
    );
  },
  get: async (id: string): Promise<ConsentTemplateDto> => {
    return await fetchPrivateApi<ConsentTemplateDto>(
      'GET',
      `consent-templates/${id}`,
    );
  },
  remove: async (id: string): Promise<void> => {
    return await fetchPrivateApi<void>('DELETE', `consent-templates/${id}`);
  },
  initFileUpload: async (
    request: InitUploadRequest,
  ): Promise<InitUploadResponse> => {
    return await fetchPrivateApi<InitUploadResponse>(
      'POST',
      `consent-templates/files/init-upload`,
      request,
    );
  },
  confirmFileUpload: async (fileId: string): Promise<void> => {
    return await fetchPrivateApi<void>(
      'POST',
      `consent-templates/files/${fileId}/confirm-upload`,
    );
  },
  getFileDownloadUrl: async (fileId: string): Promise<string> => {
    return await fetchPrivateApi<string>(
      'GET',
      `consent-templates/files/${fileId}/download-url`,
    );
  },
  getAll: async (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<ConsentTemplateListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return await fetchPrivateApi<PagedDto<ConsentTemplateListDto>>(
      'POST',
      `consent-templates/all?${params.toString()}`,
      filterCriteria,
    );
  },
  getTableDefinition: async (): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `consent-templates/table-definition`,
    );
  },
  getVariables: async (): Promise<TemplateVariableDefinitionDto[]> => {
    return await fetchPrivateApi<TemplateVariableDefinitionDto[]>(
      'GET',
      `consent-templates/variables`,
    );
  },
};

export default consentTemplatesApi;
